export default class VerifiedStatus {
  static readonly UNVERIFIED = "unverified";
  static readonly VERIFIED = "verified";
  static readonly REJECTED = "rejected";
}
